module.exports = __webpack_public_path__ + "static/img/3.3a04dba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news25/3.jpg
// module id = 9u8C
// module chunks = 1